module.exports = __webpack_public_path__ + "img/clevik_with_hand.dc792d48.png";